import { gql } from '@apollo/client';

/**
 * ТЗ 0122 — почтовый клиент ERP. Имена операций ≠ полям бэкенда (иначе
 * codegen схлопывает тип результата).
 */

export const MailMailboxesListQuery = gql`
  query MailMailboxesList {
    mailMailboxes {
      ...MailMailboxFields
    }
  }
`;

export const MailLabelsListQuery = gql`
  query MailLabelsList($mailboxIds: [ID!]) {
    mailLabels(mailboxIds: $mailboxIds) {
      ...MailLabelFields
    }
  }
`;

/** Страница тредов — читается мимо кеша Apollo (`useMailThreadList`). */
export const MailThreadsPageQuery = gql`
  query MailThreadsPage(
    $mailboxIds: [ID!]
    $view: MailView!
    $labelId: String
    $search: String
    $unreadOnly: Boolean
    $contactEmail: String
    $cursor: String
    $limit: Int
    $category: MailCategory
  ) {
    mailThreads(
      mailboxIds: $mailboxIds
      view: $view
      labelId: $labelId
      search: $search
      unreadOnly: $unreadOnly
      contactEmail: $contactEmail
      cursor: $cursor
      limit: $limit
      category: $category
    ) {
      items {
        ...MailThreadItemFields
      }
      nextCursor
      total
    }
  }
`;

export const MailThreadViewQuery = gql`
  query MailThreadView($id: ID!) {
    mailThread(id: $id) {
      id
      mailboxId
      mailboxEmail
      subject
      participants {
        email
        name
      }
      labelIds
      isStarred
      isInInbox
      snoozedUntil
      messages {
        ...MailMessageFields
      }
      actions {
        id
        action
        userName
        createdAt
      }
      linked {
        kind
        id
        title
      }
      communicatorConversationId
      people {
        email
        name
        isOurs
        kind
        id
      }
      insight {
        ...MailInsightFields
      }
      tasks {
        id
        title
        status
        assigneeName
        dueDate
      }
      sender {
        kind
        id
        title
        facts {
          key
          label
          value
          tone
        }
      }
    }
  }
`;

export const MailDraftViewQuery = gql`
  query MailDraftView($id: ID!) {
    mailDraft(id: $id) {
      ...MailDraftFields
    }
  }
`;

export const MailScheduledListQuery = gql`
  query MailScheduledList($mailboxIds: [ID!]) {
    mailScheduled(mailboxIds: $mailboxIds) {
      id
      mailboxId
      sendAt
      status
      subject
      to {
        email
        name
      }
      threadId
      error
    }
  }
`;

export const MailContactsPageQuery = gql`
  query MailContactsPage(
    $search: String
    $kind: String
    $cursor: String
    $limit: Int
  ) {
    mailContacts(search: $search, kind: $kind, cursor: $cursor, limit: $limit) {
      items {
        ...MailContactFields
      }
      nextCursor
      total
    }
  }
`;

export const MailContactSuggestListQuery = gql`
  query MailContactSuggestList($query: String!, $limit: Int) {
    mailContactSuggest(query: $query, limit: $limit) {
      email
      name
    }
  }
`;

export const MailRevisionCheckQuery = gql`
  query MailRevisionCheck($mailboxIds: [ID!]) {
    mailRevision(mailboxIds: $mailboxIds) {
      revision
      inboxUnread
    }
  }
`;

export const MailUserMailboxesListQuery = gql`
  query MailUserMailboxesList($userId: ID!) {
    mailUserMailboxes(userId: $userId) {
      mailboxId
      email
      displayName
      kind
      granted
      canSend
      implicit
    }
  }
`;

export const MailComposeDefaultsFetchQuery = gql`
  query MailComposeDefaultsFetch($messageId: ID!, $mode: MailSendMode!) {
    mailComposeDefaults(messageId: $messageId, mode: $mode) {
      to {
        email
        name
      }
      cc {
        email
        name
      }
      subject
      inReplyTo
      references
    }
  }
`;

export const MailMessageInlineImagesListQuery = gql`
  query MailMessageInlineImagesList($messageId: ID!) {
    mailMessageInlineImages(messageId: $messageId) {
      cid
      url
    }
  }
`;

export const MailAiStatusCheckQuery = gql`
  query MailAiStatusCheck {
    mailAiStatus {
      enabled
      autoTriage
      autoDraft
    }
  }
`;

/** Тред почты по Gmail-треду коммуникатора («Открыть в почте»). */
export const MailThreadIdByGmailQuery = gql`
  query MailThreadIdByGmail($mailboxEmail: String!, $gmailThreadId: String!) {
    mailThreadByGmailId(
      mailboxEmail: $mailboxEmail
      gmailThreadId: $gmailThreadId
    )
  }
`;

/** Готовый фоновый черновик ответа (или null). */
export const MailAiDraftFetchQuery = gql`
  query MailAiDraftFetch($threadId: ID!) {
    mailAiDraft(threadId: $threadId) {
      ...MailAiReplyFields
    }
  }
`;

/** Счётчики раздела «ИИ» левой колонки. */
export const MailAiViewCountsCheckQuery = gql`
  query MailAiViewCountsCheck($mailboxIds: [ID!]) {
    mailAiViewCounts(mailboxIds: $mailboxIds) {
      needsReply
      urgent
      awaiting
      deadline
    }
  }
`;
